export default {
  functionKey: "CODE",
  title: "CODE",
  group: "Texte",
  origin: [],
  target: [],
  description: "Retourne le code ASCII du premier caractère. (Ex: CODE('A') -> 65)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.charCodeAt(0);`;
    return { displayCode: code, safeCode: code };
  }
}
